'use strict';

var GridUserActionButtonDirective = function GridUserActionButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-user-action-button.html'),
    controller: 'GridUserActionButtonController',
    link: function link($scope) {
      $scope.$on('grid:rowSelectionChanged', function (event, selectedRows, gridId, allRows) {
        $scope.onRowSelection(event, selectedRows, gridId, allRows);
      });
    }
  };
};
GridUserActionButtonDirective.$inject = [];
module.exports = GridUserActionButtonDirective;